import { GuestProfile } from '@mews-commander/guest-profile';
import { LocalizedDateFromUtc } from '@mews-commander/ui';
import { UnicodeEntity } from '@mews/enums';
import { lt } from '@mews/framework';
import { Stack, Typography } from '@optimus-web/core';

export const GuestMetaInfo = ({ createdUtc, updatedUtc }: Pick<GuestProfile, 'createdUtc' | 'updatedUtc'>) => (
    <Stack vertical itemAlignment="start">
        <Typography textStyle="bodyMedium" variant="secondary" align="left" as="div">
            <>{lt('Created')}</>
            <>{UnicodeEntity.Space}</>
            <LocalizedDateFromUtc utcString={createdUtc} />
        </Typography>
        <Typography textStyle="bodyMedium" variant="secondary" align="left" as="div">
            <>{lt('LastUpdated')}</>
            <>{UnicodeEntity.Space}</>
            <LocalizedDateFromUtc utcString={updatedUtc} />
        </Typography>
    </Stack>
);
